export default __webpack_public_path__ + "static/media/livingroom5.40e60879.webp";